import styled from "styled-components";
import { colors } from "@pepdirect/v3/styles/variables";

export const StyledCreditCardOption = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
  justify-content: space-between;
`;

export const StyledCreditCardsContainer = styled.div`
  display: flex;
  gap: 4px;
`;

export const StyledPaymentTypeSelector = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StyledPaymentTypeTitle = styled.strong`
  color: ${colors.gray900};
  font-size: 14px;
`;

export const StyledPaypalImg = styled.img`
  align-items: center;
  display: flex;
`;
